<template>
	<section class="app-container form-high-contrast wide-section">
		<div class="container bulkupload-review-container">
			<div class="bulk-upload-header">
				<h1>Bulk Observation Review</h1>
				<BulkUploadNavigation :user="current_user"></BulkUploadNavigation>
			</div>
			<div v-if="current_user && current_user.profile.vetter">
				<Paging></Paging>
				<PagingSummary v-model="meta"></PagingSummary>
				<table class="border--round table--alternate-row">
					<thead>
						<tr>
							<th>User</th>
							<th>Name</th>
							<th>Data</th>
							<th>Vetting Option</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="upload in uploads">
							<td>
								{{upload.user_data.display_name}}
							</td>
							<td>{{upload.name}}</td>
							<td>
								<a class="btn btn-sm" download :href="upload.file"><i class="fa fa-download"></i> Original Upload</a>
								<a class="btn btn-sm" download :href="APIBaseURL() + 'uploads/'+upload.id+'/download/' "><i class="fa fa-download"></i> OC Results</a>
							</td>
							<td>
								<div class="input-radio input-radio-left">
                                    <span class="input__label">Assign all Photo and Specimen records "Accepted", all Observed Only to "Not Vetted"</span>
                                    <input type="radio" value="1" v-model.number="upload.sighting_status" :name="'sighting_status' + upload.id" :id="'sighting_status' + upload.id + '1'">
                                    <label :for="'sighting_status' + upload.id + '1'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign to "Pending" or "Not Vetted" according to usual OC rules</span>
                                    <input type="radio" value="2" v-model.number="upload.sighting_status" :name="'sighting_status' + upload.id" :id="'sighting_status' + upload.id + '2'">
                                    <label :for="'sighting_status' + upload.id + '2'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign all "Not Vetted"</span>
                                    <input type="radio" value="3" v-model.number="upload.sighting_status" :name="'sighting_status' + upload.id" :id="'sighting_status' + upload.id + '3'">
                                    <label :for="'sighting_status' + upload.id + '3'"></label>
                                </div>
                                <div class="input-radio input-radio-left">
                                    <span class="input__label">Assign all "Pending Admin Review"</span>
                                    <input type="radio" value="4" v-model.number="upload.sighting_status" :name="'sighting_status' + upload.id" :id="'sighting_status' + upload.id + '4'">
                                    <label :for="'sighting_status' + upload.id + '4'"></label>
                                </div>
							</td>
							<td>
								<div v-if="!upload.action_status">
									<button class="btn btn-primary" @click="approve(upload)"><span class="fa fa-check"></span> Approve Import</button>
									<button class="btn btn-danger" @click="decline(upload)"><span class="fa fa-trash"></span> Decline Import</button>
								</div>
								<div v-if="upload.action_status == 'approved'">
									<span class="label label--inline label-success">approved</span>
								</div>
								<div v-if="upload.action_status == 'declined'">
									<span class="label label--inline label-danger">declined</span>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
				<Paging></Paging>
			</div>
			<div v-if="current_user && !current_user.profile.vetter">
				<div class="alert">
					<div class="alert__body">
						<span>Please login as a vetter to review uploads.</span>
					</div>
				</div>
			</div>
			<div v-if="!current_user && !loading_user">
				<div class="alert">
					<div class="alert__body">
						<span>Please login to review uploads.</span>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	import global_data from '../../main';
	import FileUpload from 'vue-upload-component'
	export default {
		name: 'BulkUploadReviewComponent',
		metaInfo: {
			title: 'Bulk Upload Review',
		},
		data: function(){
			return {
				loading_user: true,
				current_user: null,
				uploads:[],
				page: 1,
				meta: {
					page: 0,
					per_page: 0,
					total_pages: 0,
					total_results: 0,
				},
			};
		},
		mounted: function(){
			var self = this;
			global_data.$on("user_changed", function(user){
				self.get_user();
			});
			self.get_user();
		},
		methods:{
			approve:function(upload){
				var self = this;
				if (upload.sighting_status != 1 && upload.sighting_status != 2 && upload.sighting_status != 3 && upload.sighting_status != 4) {
					self.$notify({
						text: 'Please select a vetting option.',
						type: 'error',
					});
					return;
				}

				if (!confirm("Are you sure you want to approve this import?")) {
					return;
				}

				this.API({
					endpoint: 'uploads/' + upload.id,
					isPatch:true,
					postData: {
						status:'approved',
						action:upload.sighting_status
					},
					funcThen: function(response){
						self.$notify({
							text: 'Upload Approved',
							type: 'success',
						});
						upload.action_status = "approved";
					}
				});
			},
			decline:function(upload){
				if (!confirm("Are you sure you want to decline this import?")) {
					return;
				}

				var self = this;
				this.API({
					endpoint: 'uploads/' + upload.id,
					isPatch:true,
					postData: {
						status:'denied'
					},
					funcThen: function(response){
						self.$notify({
							text: 'Upload Declined',
							type: 'success',
						});
						upload.action_status = "declined";
					}
				});
			},
			get_user: function(){
				var self = this;
				self.GetAPIUser(function(user){
					self.current_user = user;
					self.loading_user = false;
				}, true);
			},
			getData:function(){
				var self = this;

				var qs = "";
				qs += "&page=" + self.page;
				qs += "&filter{status}=confirmed";
				qs += "&include[]=user.*";
				qs += "&per_page=10";
				qs += "&sort[]=-datetime";


				this.API({
					endpoint: 'uploads',
					querystring: qs,
					funcThen: function(response){
						self.meta = response.data.meta;
						self.uploads = self.mergeResponse(response.data);
						console.log(response);
					},
				});
			},
			mergeResponse:function(responseData){
				for (var i = 0; i < responseData.uploads.length; i++) {
					responseData.uploads[i].user_data = responseData.users.find(u => u.id == responseData.uploads[i].user);
					responseData.uploads[i].action_status = null;
					responseData.uploads[i].sighting_status = 0;
				}
				return responseData.uploads;
			},
		},
		computed:{
			max_page: function(){
				return this.meta.total_pages;
			}
		},
		watch:{

			page: function(){
				let query = Object.assign({}, this.$route.query);
				query.page = this.page;
				this.$router.replace({query: query});
				this.getData();
			},
			loading_user: function(){
				this.getData();
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/BulkUploadReview.vue